module.exports = __webpack_public_path__ + "assets/img/menu-decision.86546b5c.svg";